export default "__VITE_ASSET__C1Ua4paR__"